export default __webpack_public_path__ + "static/media/chat.9ca2fac2.png";